/* Mantine 9 Notifications mounts six position roots. `top` on all of them stretches
   bottom-* (top+bottom) across the viewport; top-right also gets 100vw fullWidth. */
.root {
  pointer-events: none !important;
  width: min(100%, var(--notifications-container-width, 420px)) !important;
  max-width: var(--notifications-container-width, 420px) !important;
}

.root[data-position^='top'] {
  top: var(--toast-header-offset, 72px) !important;
}

.root[data-position^='bottom'] {
  top: auto !important;
}

.root :global(*) {
  pointer-events: auto;
}

.root :global(.mantine-Notification-description) {
  overflow-wrap: anywhere;
  word-break: break-word;
}
